import { FC } from 'react';
import { Card, Stack } from '@optimus-web/core';
import { DividerList } from '../../common';
import { SectionType, SubSection as SubSectionType } from '../types';
import { SubSection } from './SubSection';

interface SectionProps {
    section: SectionType;
}

export const Section: FC<SectionProps> = ({ section }) => (
    <Card padding="200" cornerRadius="medium" data-test-id={section.id}>
        <DividerList spacing="150">
            {section.subSections.map((subSection: SubSectionType) => (
                <Stack vertical spacing="150" key={subSection.id}>
                    <SubSection subSection={subSection} />
                </Stack>
            ))}
        </DividerList>
    </Card>
);
